import { useEffect } from "react"
import { useUiStore } from "@/stores/ui-store"

/** Drop a queued agent auto-send that belongs to another project. */
export function useClearStalePendingAgentAutoSend(projectId: number) {
  const pending = useUiStore((s) => s.pendingAgentAutoSend)
  const clearPendingAgentAutoSend = useUiStore((s) => s.clearPendingAgentAutoSend)

  useEffect(() => {
    if (pending && pending.projectId !== projectId) {
      clearPendingAgentAutoSend()
    }
  }, [projectId, pending, clearPendingAgentAutoSend])
}
